// function activeStatus(e){
//   document.querySelectorAll('.custom-related-items .item').forEach((x) =>{
//     x.classList.remove('active');
//   });
//   e.classList.add('active');
//   document.querySelector('.active-layout-2 button.add-more').dataset.variantId = e.dataset.variantItem;
// }
// document.querySelector('.active-layout-2 button.add-more').addEventListener("click", (event) => {
//   //event.target.innerText = "Added!"
//   let formData = { 'items': [] };
//   let mainItem = {
//     'id': event.target.dataset.variantId,
//     'quantity': 1
//   }
//   formData.items.push(mainItem); 
  
//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify(formData)
//   })
//   .then(response => {
//     document.querySelector('#cart-notification').classList.add('active');
//     return response.json();
//   })
//   .catch((error) => {
//     console.error('Error:', error);
//   });
//   setTimeout(() => { window.location.href = "/cart"; }, 500);
// });
  



function activeStatus(e) {
  document.querySelectorAll('.custom-related-items .item').forEach((x) => {
    x.classList.remove('active');
  });
  e.classList.add('active');
  document.querySelector('.active-layout-2 button.add-more').dataset.variantId = e.dataset.variantItem;
}

document.querySelector('.active-layout-2 button.add-more').addEventListener("click", (event) => {
  let formData = { 'items': [] };

  // Main item to add to cart
  let mainItem = {
    'id': event.target.dataset.variantId,
    'quantity': 1
  };
  formData.items.push(mainItem);

  // Collect all selected upsells (checked checkboxes)
  document.querySelectorAll('.content-pack-wrapper input[type="checkbox"]:checked').forEach((checkbox) => {
    let upsellItem = {
      'id': checkbox.value,
      'quantity': 1
    };
    formData.items.push(upsellItem);
  });

  // Make the fetch request to add items to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    document.querySelector('#cart-notification').classList.add('active');
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });

  // Redirect to the cart page after a short delay
  setTimeout(() => { window.location.href = "/cart"; }, 500);
});
